import { ONE_HUNDRED_VALUE } from 'common/config/app';
import { CellValue } from 'models/interfaces/spreadsheet-types/core-types';

const clampWeightingValue = (value: CellValue): number => {
  const numericValue = Number(value);
  return Math.min(Math.max(numericValue, 0), ONE_HUNDRED_VALUE);
};

export default clampWeightingValue;
